/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../TimelineController',
	'../TimelineAPI'
], (APIFactory, Controller, TimelineAPI) => {
	class TimelineAPIImpl extends Controller {
		constructor(options) {
			super(options);

			this.addHighlight = this.addTimelineHighlight.bind(this);
			this.deleteHighlight = this.deleteTimelineHighlight.bind(this);
			this.getEpisode = this.getTimelineEpisodeById.bind(this);
			this.getEpisodeIDs = this.getTimelineEpisodeIDs.bind(this);
			this.moveEpisode = this.moveEpisodeBefore.bind(this);
			this.updateEpisodeDuration = this.updateTimelineDuration.bind(this);
			this.updateHighlight = this.updateTimelineHighlight.bind(this);
		}

		getAPI() {
			return APIFactory.createAPI(this, [TimelineAPI]);
		}
	}

	return TimelineAPIImpl;
});